module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "records-container"
  }, [_c('el-card', {
    staticClass: "records-card1"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('records')))])]), _vm._v(" "), _c('div', {
    staticClass: "main-header-right"
  }, [_c('button', {
    staticClass: "print",
    on: {
      "click": _vm.print
    }
  }, [_vm._v(_vm._s(_vm.$t('print')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Profile')) + ":")]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('uername')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Name')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Age')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('height')))]), _c('td', [_vm._v(_vm._s(_vm.$t('weight')))]), _c('td', [_vm._v(_vm._s(_vm.$t('disType')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Duration')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.profile.username))]), _c('td', [_vm._v(_vm._s(_vm.profile.name))]), _c('td', [_vm._v(_vm._s(_vm.profile.birthday))]), _c('td', [_vm._v(_vm._s(_vm.profile.height))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.profile.weight))]), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_type))]), _c('td', [_vm._v(_vm._s(_vm.profile.diabetes_diagnosis_date))])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Complications')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create1
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _c('td', [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.complications), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[1]))]), _c('td', [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit1
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete1
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Prescription')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create2
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Dose')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.prescription), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[1]))]), _c('td', [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[3]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit2
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete2
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Other suggestions')) + ":")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }],
    staticClass: "print print1",
    on: {
      "click": _vm.create3
    }
  }, [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('div', {
    staticClass: "time",
    class: {
      'zh1': !_vm.isEn
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('From')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "to"
  }, [_vm._v(_vm._s(_vm.$t('To')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.defaultDate,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)]), _vm._v(" "), _c('table', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v(_vm._s(_vm.$t('HCP')))]), _c('td', [_vm._v(_vm._s(_vm.$t('date')))]), _c('td', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.userType !== 'P')),
      expression: "(userType!=='P')"
    }]
  }, [_vm._v(_vm._s(_vm.$t('Action')))])]), _vm._v(" "), _vm._l((_vm.suggestions), function(item, index) {
    return _c('tr', {
      class: (index % 2 === 0) ? '' : 'even',
      attrs: {
        "id": index
      }
    }, [_c('td', [_vm._v(_vm._s(item[3]))]), _c('td', [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "cntW"
    }, [_vm._v(_vm._s(item[2]))]), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.userType !== 'P')),
        expression: "(userType!=='P')"
      }]
    }, [_c('span', {
      staticClass: "action",
      on: {
        "click": _vm.edit3
      }
    }, [_vm._v(_vm._s(_vm.$t('edit')))]), _c('br'), _c('span', {
      staticClass: "action",
      on: {
        "click": _vm.delete3
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.CreateVisible,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.CreateVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Create')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA),
      expression: "typeA"
    }]
  }, [_c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'cz1': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t1),
      expression: "t1"
    }],
    staticClass: "dis",
    class: {
      'zh2': !_vm.isEn
    },
    attrs: {
      "maxlength": "20",
      "placeholder": _vm.tip0
    },
    domProps: {
      "value": (_vm.t1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    staticClass: "date",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.Time,
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t2),
      expression: "t2"
    }],
    staticClass: "sugg",
    class: {
      'zh3': !_vm.isEn, 'de3': _vm.isDe, 'it3': _vm.isIt, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip1,
      "maxlength": 40
    },
    domProps: {
      "value": (_vm.t2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB),
      expression: "typeB"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t3),
      expression: "t3"
    }],
    staticClass: "medic",
    class: {
      'zh4': !_vm.isEn, 'it4': _vm.isIt, 'du4': _vm.isDu, 'cz4': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip3,
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.t3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dose')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t4),
      expression: "t4"
    }],
    staticClass: "dose1",
    class: {
      'es5': _vm.isEs, 'de4': _vm.isDe, 'it5': _vm.isIt, 'fr4': _vm.isFr, 'sw4': _vm.isSw
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip2,
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.t4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t5),
      expression: "t5"
    }],
    staticClass: "sug1",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'du5': _vm.isDu, 'fr5': _vm.isFr, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip4,
      "maxlength": 40
    },
    domProps: {
      "value": (_vm.t5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC),
      expression: "typeC"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('HCP')))]), _vm._v(" "), _c('span', {
    staticClass: "hcp",
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'du7': _vm.isDu, 'cz7': _vm.isCz
    },
    model: {
      value: (_vm.t6),
      callback: function($$v) {
        _vm.t6 = $$v
      },
      expression: "t6"
    }
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh8': !_vm.isEn, 'po8': _vm.isPo || _vm.isDu || _vm.isFr
    },
    staticStyle: {
      "margin-right": "73px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('span', {
    staticClass: "now",
    class: {
      'de8': _vm.isDe, 'po9': _vm.isPo
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }, [_vm._v(_vm._s(_vm.now))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "long-span"
  }, [_vm._v(_vm._s(_vm.$t('Content')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.t7),
      expression: "t7"
    }],
    staticClass: "textArea",
    class: {
      'zh6': !_vm.isEn, 'it7': _vm.isIt, 'cz8': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip5,
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.t7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.t7 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA),
      expression: "typeA"
    }],
    on: {
      "click": _vm.createRecord1
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB),
      expression: "typeB"
    }],
    on: {
      "click": _vm.createRecord2
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC),
      expression: "typeC"
    }],
    on: {
      "click": _vm.createRecord3
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-form2",
    attrs: {
      "visible": _vm.EditVisible,
      "size": _vm.dialogSize,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.EditVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel1
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA1),
      expression: "typeA1"
    }]
  }, [_c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    class: {
      'de1': _vm.isDe, 'it1': _vm.isIt, 'cz1': _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Concomitant diseases')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote0),
      expression: "edNote0"
    }],
    staticClass: "dis",
    class: {
      'zh2': !_vm.isEn
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip0,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote0)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote0 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont",
    class: {
      'es1': _vm.isEs
    }
  }, [_c('span', {
    staticClass: "date",
    class: {
      'es2': _vm.isEs, 'de2': _vm.isDe, 'du2': _vm.isDu, 'fr2': _vm.isFr, 'sw2': _vm.isSw
    }
  }, [_vm._v(_vm._s(_vm.$t('disDate')))]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "clearable": false,
      "placeholder": _vm.comp[2],
      "format": "dd-MM-yyyy"
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Suggestion')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote1),
      expression: "edNote1"
    }],
    staticClass: "sugg",
    class: {
      'zh3': !_vm.isEn, 'de3': _vm.isDe, 'it3': _vm.isIt, 'po3': _vm.isPo, 'du3': _vm.isDu, 'fr3': _vm.isFr, 'sw3': _vm.isSw, 'cz3': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip1,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB1),
      expression: "typeB1"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Medicine')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote2),
      expression: "edNote2"
    }],
    staticClass: "medic",
    class: {
      'zh4': !_vm.isEn, 'it4': _vm.isIt, 'du4': _vm.isDu, 'cz4': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip3,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.edNote2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Dose')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote3),
      expression: "edNote3"
    }],
    staticClass: "dose1",
    class: {
      'es5': _vm.isEs, 'de4': _vm.isDe, 'it5': _vm.isIt, 'fr4': _vm.isFr, 'sw4': _vm.isSw
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip2,
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.edNote3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote4),
      expression: "edNote4"
    }],
    staticClass: "sug1",
    class: {
      'zh5': !_vm.isEn, 'de5': _vm.isDe, 'du5': _vm.isDu, 'fr5': _vm.isFr, 'sw5': _vm.isSw, 'cz5': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip4,
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.edNote4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote4 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC1),
      expression: "typeC1"
    }]
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('HCP')))]), _vm._v(" "), _c('span', {
    staticClass: "hcp",
    class: {
      'zh7': !_vm.isEn, 'es7': _vm.isEs, 'du7': _vm.isDu, 'cz7': _vm.isCz
    },
    model: {
      value: (_vm.sug[3]),
      callback: function($$v) {
        var $$exp = _vm.sug,
          $$idx = 3;
        if (!Array.isArray($$exp)) {
          _vm.sug[3] = $$v
        } else {
          $$exp.splice($$idx, 1, $$v)
        }
      },
      expression: "sug[3]"
    }
  }, [_vm._v(_vm._s(_vm.sug[3]))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "date",
    class: {
      'zh8': !_vm.isEn, 'po8': _vm.isPo || _vm.isDu || _vm.isFr
    },
    staticStyle: {
      "margin-right": "73px"
    }
  }, [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('span', {
    staticClass: "now",
    class: {
      'de8': _vm.isDe, 'po9': _vm.isPo
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  }, [_vm._v(_vm._s(_vm.now))])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "long-span"
  }, [_vm._v(_vm._s(_vm.$t('Content')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edNote5),
      expression: "edNote5"
    }],
    staticClass: "textArea",
    class: {
      'zh6': !_vm.isEn, 'it7': _vm.isIt, 'cz8': _vm.isCz
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.tip5,
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.edNote5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edNote5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "patientList-small-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeA1),
      expression: "typeA1"
    }],
    on: {
      "click": _vm.editRecords1
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeB1),
      expression: "typeB1"
    }],
    on: {
      "click": _vm.editRecords2
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeC1),
      expression: "typeC1"
    }],
    on: {
      "click": _vm.editRecords3
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel1
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ca1f2bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/records.vue
// module id = 1490
// module chunks = 7